import React from 'react';
import type { Organism } from '@verndale/core';
import { renderElement } from './helpers/react-18-shim';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactModule = (Component: any, nodeList: NodeListOf<HTMLElement>) => {
  return nodeList.forEach(node => {
    renderElement(<Component {...node.dataset} />, node);
  });
};

const globModules: Organism[] = [
  {
    name: 'alphabet-filtered-links-list',
    loader: () => import('./modules/alphabet-filtered-links-list')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'video',
    loader: () => import('./modules/video.js')
  },
  {
    name: 'simple-video',
    loader: () => import('./modules/simple-video')
  },
  {
    name: 'horizontal-top-navigation-row',
    loader: () => import('./modules/horizontal-top-navigation-row')
  },
  {
    name: 'staff-gallery-row',
    loader: () => import('./modules/staff-gallery-row')
  },
  {
    name: 'h1-heading',
    loader: () => import('./modules/h1-heading')
  },
  {
    name: 'accordion-with-colored-cards',
    loader: () => import('./modules/accordion-with-colored-cards')
  },
  {
    name: 'return-to-top',
    loader: () => import('./modules/return-to-top')
  },
  {
    name: 'locations-map-row',
    loader: () => import('./modules/locations-map-row')
  },
  {
    name: 'map',
    loader: () => import('./modules/map')
  },
  {
    name: 'modal-link-button',
    loader: () => import('./modules/modal-link-button')
  },
  {
    name: 'image-carousel-row',
    loader: () => import('./modules/image-carousel-row')
  },
  {
    name: 'accordion-content-row',
    loader: () => import('./modules/accordion-content-row')
  },
  {
    name: 'actions-list',
    loader: () => import('./modules/actions-list')
  },
  {
    name: 'simple-condition-search-masthead',
    loader: () => import('./modules/simple-condition-search-masthead')
  },
  {
    name: 'publications-row',
    loader: () => import('./modules/publications-row')
  },
  {
    name: 'global-search-header',
    loader: () => import('./modules/global-search-header'),
    render: reactModule
  },
  {
    name: 'global-search-results',
    loader: () => import('./modules/global-search-results'),
    render: reactModule
  },
  {
    name: 'patient-search-results',
    loader: () => import('./modules/patient-search-results'),
    render: reactModule
  },
  {
    name: 'shared-links',
    loader: () => import('./modules/shared-links')
  },
  {
    name: 'card-swiper',
    loader: () => import('./modules/card-swiper')
  },
  {
    name: 'media-carousel',
    loader: () => import('./modules/media-carousel')
  },
  {
    name: 'patient-story-submission-form',
    loader: () => import('./modules/patient-story-submission-form'),
    render: reactModule
  },
  {
    name: 'testimonial-carousel',
    loader: () => import('./modules/testimonial-carousel')
  }
];

export default globModules;
